// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12395":"0eac2e53","27954":"83d3e365","35933":"b38ec32a","42190":"c5135f2c","67768":"e7be7ab1","71360":"b38ec32a","85930":"0eac2e53","96037":"b38ec32a"}[chunkId] + ".chunk.css";
};